function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup0304Ico01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.53 74.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M43.22,27.64c0,6.24-5.06,11.3-11.3,11.3s-11.3-5.06-11.3-11.3,5.06-11.3,11.3-11.3,11.3,5.06,11.3,11.3ZM56.39,73.04v-5.35c0-5.72-5.48-8.67-12.23-8.67s-12.24,2.95-12.24,8.67v1.26M63.99,40.85c-5.84,0-10.57-4.73-10.57-10.57s4.73-10.57,10.57-10.57,10.57,4.73,10.57,10.57-4.73,10.57-10.57,10.57ZM55.39,47.05c3.06-1.03,6.2-1.14,8.6-1.14,6.64,0,12.43,2.13,15.63,6.02,3.76-3.9,7.07-7.72,9.38-11.13,11.77-17.44-1.31-39.71-21.24-39.71-8.48,0-15.97,4.15-20.62,10.49C42.47,5.23,34.99,1.08,26.51,1.08,6.93,1.08-5.59,21.74,4.85,40.24c2.24,3.97,5.49,8.1,9.2,12.14,1.74-2.88,4.66-5.04,8.31-6.38,3.72-1.36,7.03-1.8,10.66-1.46M44.15,39.7c-4.2,0-7.6,3.4-7.6,7.59s3.4,7.6,7.6,7.6,7.59-3.4,7.59-7.6-3.4-7.59-7.59-7.59Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.15px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup0304Ico01);
export default __webpack_public_path__ + "static/media/sezione-05-popup-03-04-ico-01.5495e163599f6c292ff23ddc2d9b70ff.svg";
export { ForwardRef as ReactComponent };